var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDoubleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3047 4.47136C12.5651 4.21101 12.5651 3.7889 12.3047 3.52855C12.0444 3.26821 11.6223 3.26821 11.3619 3.52855L7.36193 7.52855C7.10158 7.7889 7.10158 8.21101 7.36193 8.47136L11.3619 12.4714C11.6223 12.7317 12.0444 12.7317 12.3047 12.4714C12.5651 12.211 12.5651 11.7889 12.3047 11.5286L8.77614 7.99996L12.3047 4.47136Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63811 4.47136C8.89846 4.21101 8.89846 3.7889 8.63811 3.52855C8.37776 3.26821 7.95565 3.2682 7.6953 3.52855L3.6953 7.52855C3.43495 7.7889 3.43495 8.21101 3.6953 8.47136L7.6953 12.4714C7.95565 12.7317 8.37776 12.7317 8.63811 12.4714C8.89846 12.211 8.89846 11.7889 8.63811 11.5286L5.10952 7.99996L8.63811 4.47136Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleLeft);
export default __webpack_public_path__ + "static/media/chevron-double-left.2af9bceb3ca88552d00ef0533c584893.svg";
export { ForwardRef as ReactComponent };